import { render, staticRenderFns } from "./productClassification.vue?vue&type=template&id=0397642d&scoped=true&"
import script from "./productClassification.vue?vue&type=script&lang=js&"
export * from "./productClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397642d",
  null
  
)

export default component.exports